import React, { Fragment, useEffect, useState, useContext } from 'react'
import { Link, withRouter } from 'react-router-dom'
import styled, { css } from 'styled-components';
import { Context } from '../context';
import { UIinput } from '../uikit/UIinput';

export function MetadataSearch(props) {
  const context = useContext(Context);
  const [query, setQuery] = useState('');
  return (
    <>

      <div className="l_content_info_section">
        <div className="l_info_line">
          {/* <div className="l_video_info_title">
            Metadata threads
          </div> */}


          <UIinput label='Find text comment or a thread' width="100%"
            style={{
              border: '2px solid var(--main-accent-color)',
              borderRadius: '0.6em'
            }}
            // extra={'x'}
            icon={<div className='ico'>search</div>}
            value={query}
            handle={(q) => {
              setQuery(q)
            }}
          >
          </UIinput>

        </div>
      </div >
    </>
  )
}